import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import MarketplaceCategoryPicker from './MarketplaceCategoryPicker';

export interface MarketplaceCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Channel identifier `shop:N`. */
  source: string;
  /** Article the category is assigned to; nothing is rendered when null. */
  wawiArtikelId: number | null;
  /** Product title shown under the modal title for context. */
  productTitle?: string | null;
  dataSourceId?: string | null;
}

/**
 * Standalone "assign a marketplace category" modal for ONE product - opened
 * from the product list's no-category "!" indicator, independent from the
 * bulk generate modal's category gate. The success toast and the Redux list
 * patch happen inside the picker itself; the modal only has to close.
 */
const MarketplaceCategoryModal: React.FC<MarketplaceCategoryModalProps> = ({
  isOpen,
  onClose,
  source,
  wawiArtikelId,
  productTitle,
  dataSourceId,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('marketplace_listing_assign_category')}
      isCentered
      className="marketplace-category-modal"
      hideCloseButton={true}
    >
      {productTitle ? (
        <div className="marketplace-category-modal__product">{productTitle}</div>
      ) : null}
      {wawiArtikelId != null ? (
        <MarketplaceCategoryPicker
          source={source}
          wawiArtikelId={wawiArtikelId}
          dataSourceId={dataSourceId}
          onAssigned={onClose}
        />
      ) : null}
    </Modal>
  );
};

export default MarketplaceCategoryModal;
